import React, { useState } from "react";
import { Link } from "react-router-dom";
import { 
  FaImage, 
  FaVideo, 
  FaCalendarAlt, 
  FaGraduationCap,
  FaBuilding,
  FaUsers,
  FaTrophy,
  FaArrowLeft,
  FaArrowRight,
  FaTimes
} from "react-icons/fa";

const GalleryPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedImage, setSelectedImage] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(0);

  const categories = [
    { id: "all", name: "All", icon: <FaImage /> },
  ];

  // Updated with unique IDs for each image
  const allImages = [
    { id: 1, image: "image1.jpg" },
    { id: 2, image: "image2.jpg" },
    { id: 3, image: "image3.jpg" },
    { id: 4, image: "image4.jpg" },
    { id: 5, image: "image6.jpg"},
    { id: 6, image: "image7.jpg"},
    { id: 7, image: "image8.jpg"},
    { id: 8, image: "image9.jpg" },
    { id: 9, image: "image10.jpg"},
    { id: 10, image: "image11.jpg"},
    { id: 11, image: "image12.jpg" },
    { id: 12, image: "image13.jpg"},
    { id: 13, image: "image14.jpg" },
    { id: 14, image: "image15.jpg"},
    { id: 15, image: "image16.jpg" },
    { id: 16, image: "image17.jpg"  },
    { id: 17, image: "image18.jpg" },
    { id: 18, image: "image19.jpg" },
    { id: 19, image: "image20.jpg"},
    { id: 20, image: "image21.jpg" },
    { id: 21, image: "image22.jpg" },
    { id: 22, image: "image23.jpg" },
    { id: 23, image: "image25.jpg"},
    { id: 24, image: "image26.jpg"},
    { id: 25, image: "image27.jpg"},
    { id: 26, image: "image28.jpg" },
    { id: 27, image: "image29.jpg"},
    { id: 28, image: "image30.jpg" },
    { id: 29, image: "image31.jpg" },
    { id: 30, image: "image32.jpg"},
    { id: 31, image: "image34.jpg"},
    { id: 32, image: "image35.jpg" },
    { id: 33, image: "image36.jpg" },
    { id: 34, image: "image37.jpg"},
    { id: 35, image: "image38.jpg"},
    { id: 36, image: "image39.jpg"},
    { id: 37, image: "image40.jpg"},
    { id: 38, image: "image41.jpg"},
    { id: 39, image: "image42.jpg" },
    { id: 40, image: "image43.jpg"},
    { id: 41, image: "image44.jpg" },
    { id: 42, image: "image45.jpg" },
    { id: 43, image: "image46.jpg" },
    { id: 44, image: "image47.jpg"},
    { id: 45, image: "image48.jpg" },
    { id: 46, image: "image49.jpg"},
    { id: 47, image: "image50.jpg" },
    { id: 48, image: "image51.jpg"},
    { id: 49, image: "image52.jpg" },
    { id: 50, image: "image53.jpg" },
    { id: 51, image: "image54.jpg"},
    { id: 52, image: "image55.jpg" },
    { id: 53, image: "image56.jpg"},
    { id: 54, image: "image57.jpg" },
    { id: 55, image: "image58.jpg" },
    { id: 56, image: "image59.jpg"},
    { id: 57, image: "image60.jpg"}
  ];

  const getPlaceholderImage = (id, category) => {
    const colors = {
      campus: "3b82f6",
      events: "8b5cf6",
      students: "10b981",
      graduation: "f59e0b",
      achievements: "ef4444"
    };
    const color = colors[category] || "3b82f6";
    return `https://placehold.co/600x400/${color}/white?text=${category}+${id}`;
  };

  const galleryImages = allImages.map(img => ({
    ...img,
    image: img.image,
    fallbackImage: getPlaceholderImage(img.id, img.category)
  }));

  const filteredImages = selectedCategory === "all" 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  const openLightbox = (image, index) => {
    setSelectedImage(image);
    setLightboxIndex(index);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
  };

  const navigateLightbox = (direction) => {
    const currentIndex = filteredImages.findIndex(img => img.id === selectedImage.id);
    let newIndex;
    
    if (direction === 'next') {
      newIndex = (currentIndex + 1) % filteredImages.length;
    } else {
      newIndex = (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    }
    
    setSelectedImage(filteredImages[newIndex]);
    setLightboxIndex(newIndex);
  };

  const handleImageError = (e, fallbackSrc) => {
    e.target.onerror = null;
    e.target.src = fallbackSrc;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 py-12 px-4">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <nav className="flex text-sm text-gray-500">
            <Link to="/" className="hover:text-blue-600">Home</Link>
            <span className="mx-2">/</span>
            <span className="text-blue-600 font-semibold">Gallery</span>
          </nav>
        </div>
        <div className="bg-gradient-to-r from-purple-600 to-pink-600 rounded-3xl p-8 mb-8 text-white">
          <div className="flex items-center gap-4">
            <div className="bg-white/30 p-4 rounded-2xl">
              <FaImage className="text-4xl" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold">Gallery</h1>
              <p className="text-white/90 mt-2"> Moments captured at R.D.S. NURSING & PARAMEDICAL COLLEGE</p>
            </div>
          </div>
        </div>
        <div className="mb-8">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 flex items-center gap-2 ${
                  selectedCategory === category.id
                    ? "bg-gradient-to-r from-blue-600 to-green-600 text-white"
                    : "bg-white text-gray-600 hover:bg-gray-100"
                }`}
              >
                <span>{category.icon}</span>
                {category.name} 
                <span className="ml-1 text-xs">
                  ({category.id === 'all' ? galleryImages.length : galleryImages.filter(img => img.category === category.id).length})
                </span>
              </button>
            ))}
          </div>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
          {filteredImages.map((image, index) => (
            <div
              key={image.id}  
              onClick={() => openLightbox(image, index)}
              className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl cursor-pointer aspect-square bg-gray-100 transition-all duration-300 hover:scale-105"
            >
              <img
                src={image.image}
                alt={`Gallery image ${image.id}`}
                className="w-full h-full object-cover"
                onError={(e) => handleImageError(e, image.fallbackImage)}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-2 text-white">
                  <p className="font-semibold text-xs sm:text-sm truncate">{image.title}</p>
                  <p className="text-[10px] sm:text-xs opacity-80">{image.date}</p>
                </div>
              </div>
              <div className="absolute top-1 right-1 bg-black/50 text-white text-[10px] px-1.5 py-0.5 rounded">
                #{image.id}
              </div>
              <div className="absolute top-1 left-1 bg-blue-600 text-white text-[8px] px-1.5 py-0.5 rounded uppercase">
                {image.category}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-6 text-center text-sm text-gray-500">
          Showing {filteredImages.length} of {galleryImages.length} images
          <span className="ml-2 text-xs">(Image 1 to 60)</span>
        </div>
        {filteredImages.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500">No images found in this category.</p>
          </div>
        )}
        {selectedImage && (
          <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4">
            <button
              onClick={closeLightbox}
              className="absolute top-4 right-4 text-white hover:text-gray-300 z-10 bg-black/50 p-3 rounded-full"
            >
              <FaTimes size={20} />
            </button>
            
            <button
              onClick={() => navigateLightbox('prev')}
              className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 bg-black/50 p-3 rounded-full"
            >
              <FaArrowLeft size={20} />
            </button>
            
            <button
              onClick={() => navigateLightbox('next')}
              className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 text-white hover:text-gray-300 bg-black/50 p-3 rounded-full"
            >
              <FaArrowRight size={20} />
            </button>
            
            <div className="max-w-5xl max-h-[85vh] w-full">
              <div className="relative h-full flex flex-col">
                <div className="flex-1 flex items-center justify-center bg-black/50 rounded-lg overflow-hidden p-2">
                  <img
                    src={selectedImage.image}
                    alt={selectedImage.title}
                    className="max-w-full max-h-[70vh] object-contain"
                    onError={(e) => handleImageError(e, selectedImage.fallbackImage)}
                  />
                </div>
                <div className="text-white text-center mt-4 bg-black/50 p-4 rounded-lg">
                  <p className="text-lg md:text-xl font-semibold">{selectedImage.title}</p>
                  <p className="text-sm opacity-80">{selectedImage.date}</p>
                  <p className="text-xs opacity-60 mt-1">Image {selectedImage.id} of 60 | Category: {selectedImage.category}</p>
                </div>
              </div>
            </div>
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 text-white text-sm bg-black/50 px-3 py-1 rounded-full">
              {lightboxIndex + 1} / {filteredImages.length}
            </div>
          </div>
        )}
        <div className="mt-16">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">Campus Videos</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-video bg-gray-200 flex items-center justify-center">
                <FaVideo className="text-5xl text-gray-400" />
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-gray-800">Campus Tour</h3>
                <p className="text-sm text-gray-500">2:30 min</p>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-video bg-gray-200 flex items-center justify-center">
                <FaVideo className="text-5xl text-gray-400" />
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-gray-800">Annual Function 2024</h3>
                <p className="text-sm text-gray-500">5:15 min</p>
              </div>
            </div>
            <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="aspect-video bg-gray-200 flex items-center justify-center">
                <FaVideo className="text-5xl text-gray-400" />
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-gray-800">Student Testimonials</h3>
                <p className="text-sm text-gray-500">3:45 min</p>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-8 text-center">
          <button className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-green-600 text-white font-semibold rounded-xl hover:from-blue-700 hover:to-green-700 transition-all duration-300">
            <FaImage /> Download Gallery PDF
          </button>
        </div>
      </div>
    </div>
  );
};

export default GalleryPage;